export default import.meta.ROLLUP_FILE_URL_bTTvm9QuQiybJMfZH83GhQ